<template>
  <the-dialog-box
    ref="dialogBox"
    :submit="submitMoveForward"
    :is-submit-btn="canMoveForward"
    :submit-btn-text="moveForwardText"    
    :is-secondary-btn="canUndo"
    :secondary-submit="submitUndo"
    :secondary-btn-text="undoText"
    :max-width="700"
  >
    <template slot="header">
      <div
        style="width: 100%;"
        class="d-flex justify-space-between align-center pa-3"
      >
        <span
          v-if="item"
          class="f6 fw600"
        >Batch - {{ item.qr_code_value }}</span>
        <div
          class="d-flex"
          style="gap: 6px;"
        >
          <v-chip
            :color="item && item.class ? item.class.color : 'black'"
            text-color="white"
          >
            {{ item && item.class ? item.class.name : '' }}
          </v-chip>
          <v-chip
            :color="item && item.status ? item.status.color : 'black'"
            text-color="white"
          >
            {{ item && item.status ? item.status.name : '' }}
          </v-chip>
        </div>
      </div>
    </template>
    <template slot="body">
      <!-- panel_code, description, color.name -->
      <div
        v-if="item"
        class="d-flex flex-column ga-6 pa-3 pb-6 pt-0"
      >
        <div class="d-flex flex-column ga-1">
          <span class="title-span">Job</span>
          <div class="desc-div">
            <span
              class="desc-span"
              style="font-weight: bold;"
            >{{ item.job_code ? `${item.job_code}` : '' }}</span> - <span class="desc-span">{{ item.job_name ? item.job_name : item.job_name }}</span> <span
              class="desc-span"
              style="color: #1976D2;"
            >{{ item.job_reference ? `; ${item.job_reference}` : '' }}</span>
          </div>
        </div>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">Panel Type</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.panel_code }}</span>
            </div>
          </div>
          <!-- <div class="outer-div">
            <span class="title-span">Color</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.color ? item.color.name : 'No Color' }}</span>
            </div>
          </div> -->
        </div>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">Description</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.description }}</span>
            </div>
          </div>
        </div>

        <div class="d-flex ga-3 align-center">
          <div class="outer-div">
            <span class="title-span">Quantity</span>
            <div class="desc-div">
              <span class="desc-span">{{ item.total_wip_panels }}</span>
            </div>
          </div>
        </div>

        <!-- <v-divider style="border-bottom: 1px solid #BDBDBD;" />
        <span
          class="f8 fw600"
          style="color: #000"
        >Stage Management</span>

        <div class="outer-div">
          <span class="title-span">Move to Stage</span>
          <v-select
            v-model="selectedStatusId"
            :items="batchStatuses"
            item-text="name"
            item-value="id"
            hide-details="true"
            outlined
            clearable
            :rules="[(v) => !!v || 'Move to Stage is required']"
            placeholder="Select Stage"
          >
            <template #item="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
            <template #selection="{ item }">
              <v-chip
                class="mt-1 mb-1"
                small
                text-color="white"
                style="cursor: pointer;"
                :color="item ? item.color : 'white'"
              >
                {{ item ? item.name : '' }}
              </v-chip>
            </template>
          </v-select>
        </div> -->
      </div>
    </template>
  </the-dialog-box>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
  components: {

  },
  props: {

  },
  data: () => ({
    item: null,
    statusIdNew: 1,
    statusIdCutting: 8,
    statusIdTempering: 9,
    statusIdInProduction: 2,
    statusIdProduced: 3,
    statusIdShipped: 5,
    statusIdReceived: 7,
    statusIdShippedToSite: 10,
    statusIdReceivedOnSite: 11,
    statusIdPShippedToSite: 12,
    statusIdPReceivedOnSite: 13,
    wipPanelScheduleStatusIdCurrent: 1,
    selectedStatusId: null,
    loadingBatchStatuses: false,
    batchStatuses: [],
    customPanelWorkflow4800: false,
    customPanelWorkflow6000: false,
  }),
  computed: {
    ...mapState({

    }),
    ...mapGetters([
      'businessRulesGetBoolean',
    ]),

    isCustomPanelWorkflow() {
      const itemClassName = this.item && this.item.class ? this.item.class.name : '';

      return (
        (itemClassName.includes('4800') && this.customPanelWorkflow4800)
        || (itemClassName.includes('6000') && this.customPanelWorkflow6000)
      );
    },

    canMoveForward() {
      if (!this.item) {
        return false;
      }

      if (this.item.status_id === this.statusIdNew) {
        return true;
      }

      if (this.item.status_id === this.statusIdCutting) {
        return this.isCustomPanelWorkflow;
      }

      return false;
    },

    moveForwardText() {
      if (!this.item) {
        return '';
      }

      if (this.item.status_id === this.statusIdNew) {
        return 'MOVE TO CUTTING';
      }

      if (this.item.status_id === this.statusIdCutting) {
        return 'MOVE TO PRODUCED';
      }

      return '';
    },

    canUndo() {
      if (!this.item) {
        return false;
      }

      if (this.item.status_id === this.statusIdCutting) {
        return true;
      }

      if (this.item.status_id === this.statusIdProduced) {
        return this.isCustomPanelWorkflow;
      }

      return false;
    },

    undoText() {
      if (!this.item) {
        return '';
      }

      if (this.item.status_id === this.statusIdCutting) {
        return 'UNDO CUTTING';
      }

      if (this.item.status_id === this.statusIdProduced) {
        return 'UNDO PRODUCED';
      }

      return '';
    },
  },
  watch: {

  },
  created() {
    this.item = { ...this.itemDto };
    const customPanelWorkflow4800 = '4800 Custom Panel Workflow';
    this.customPanelWorkflow4800 = this.businessRulesGetBoolean(customPanelWorkflow4800);
    const customPanelWorkflow6000 = '6000 Custom Panel Workflow';
    this.customPanelWorkflow6000 = this.businessRulesGetBoolean(customPanelWorkflow6000);
  },
  methods: {

    async get(qrCodeValue) {
      this.$bus.$emit('loading');
      const submitModel = {
        filters: {
          qr_code_value: qrCodeValue,
          is_all: 1,
        },
        includes: {
          is_include_wip_panel_schedule: 1,
        },
      };
      const res = await this.$api.wipPanelBatch.read(submitModel);
      if (!res || !res.data || res.data.length === 0) {
        this.$bus.$emit('loading-stop');
        this.item = null;
        return;
      }
      const firstIndex = 0;
      this.item = res.data[firstIndex];
      // if the associated panel schedule is not in current then show error
      if (!this.item.wip_panel_schedule) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Error, there is no associated panel schedule for this batch. Please contact support.');
        this.item = null;
        return;
      }
      if (this.item.wip_panel_schedule && this.item.wip_panel_schedule.status_id != this.wipPanelScheduleStatusIdCurrent) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Please schedule the associated panel schedule to CURRENT status before moving this batch.');
        this.item = null;
        return;
      }

      const isAllowed = this.item.status_id === this.statusIdNew || this.item.status_id === this.statusIdCutting || this.item.status_id === this.statusIdTempering || (this.item.status_id === this.statusIdProduced && this.isCustomPanelWorkflow);
      if (!isAllowed) {
        this.$bus.$emit('loading-stop');
        this.$bus.$emit('showError', 'Batch cannot be changed. Please check the status of the batch.');
        this.item = null;
        return;
      }
      // await this.getBatchStatuses();
      this.$bus.$emit('loading-stop');
    },

    async getBatchStatuses() {
      //if itemClass is like 4800 or 6000 and the respective business rules are true then show NEW, CUTTING and PRODUCED. Otherwise show NEW, CUTTING
      const statuses = [];
      const itemClassName = this.item.class ? this.item.class.name : '';
      if ((itemClassName.includes('4800') && this.customPanelWorkflow4800) || (itemClassName.includes('6000') && this.customPanelWorkflow6000)) {
        statuses.push(this.statusIdNew, this.statusIdCutting, this.statusIdProduced);
      } else {
        statuses.push(this.statusIdNew, this.statusIdCutting);
      }


      const submitModel = {
        filters: {
            status_id: statuses,
          },
      };
      const res = await this.$api.wipPanelBatchStatus.read(submitModel);
      if (!res) {
        this.batchStatuses = [];
        return;
      }
      this.batchStatuses = res;
    },

    async submit() {
      if (!this.selectedStatusId) {
        this.$bus.$emit('showError', 'Please select a stage.');
        return false;
      }

      const submitModel = {
        batch_id: this.item.id,
        status_id: this.selectedStatusId,
      };
      const res = await this.$api.wipPanelBatch.store(submitModel, 'change-status');

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;
      if (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (!res) {
        this.$bus.$emit('showError', res);
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    async submitMoveForward() {
      let statusId = null;

      if (this.item.status_id === this.statusIdNew) {
        statusId = this.statusIdCutting;
      } else if (this.item.status_id === this.statusIdCutting) {
        statusId = this.isCustomPanelWorkflow ? this.statusIdProduced : null;
      }

      if (!statusId) {
        this.$bus.$emit('showError', 'Unable to determine the next stage.');
        return false;
      }

      return await this.changeStatus(statusId);
    },

    async submitUndo() {
      let statusId = null;

      if (this.item.status_id === this.statusIdCutting) {
        statusId = this.statusIdNew;
      } else if (this.item.status_id === this.statusIdProduced) {
        statusId = this.statusIdCutting;
      }

      return await this.changeStatus(statusId);
    },

    async changeStatus(statusId) {
      if (!statusId) {
        this.$bus.$emit('showError', 'Unable to determine the next stage.');
        return false;
      }

      const submitModel = {
        batch_id: this.item.id,
        status_id: statusId,
      };

      const res = await this.$api.wipPanelBatch.store(submitModel, 'change-status');

      const httpStatusCodeConflict = 409;
      const httpStatusCodeNotExtended = 510;

      if (res && (res.status === httpStatusCodeConflict || res.status === httpStatusCodeNotExtended)) {
        this.$bus.$emit('showError', res.message);
        return false;
      }

      if (!res) {
        this.$bus.$emit('showError');
        return false;
      }

      this.$bus.$emit('showSuccess');
      this.$emit('success');
      return res;
    },

    // async submit() {
    //   const submitModel = {
    //     batch_id: this.item.id,
    //     status_id: this.item.status_id === this.statusIdNew ? this.statusIdCutting : this.statusIdTempering,
    //   };
    //   const res = await this.$api.wipPanelBatch.store(submitModel, 'toggle-stage');

    //   if (!res) {
    //     this.$bus.$emit('showError');
    //     return false;
    //   }

    //   this.$bus.$emit('showSuccess');
    //   this.$emit('success');
    //   return res;
    // },

    // async submitUndo() {
    //   const submitModel = {
    //     batch_id: this.item.id,
    //     status_id: this.item.status_id === this.statusIdCutting ? this.statusIdNew : this.statusIdCutting,
    //   };
    //   const res = await this.$api.wipPanelBatch.store(submitModel, 'toggle-stage');

    //   if (!res) {
    //     this.$bus.$emit('showError');
    //     return false;
    //   }

    //   this.$bus.$emit('showSuccess');
    //   this.$emit('success');
    //   return res;
    // },

    async open(batchCode) {
      if (batchCode) {
        await this.get(batchCode);
        if (this.item === null) {
          this.$bus.$emit('showError', 'Unrecognized Batch QR Code');
          return;
        }
      } else {
        this.item = { ...this.itemDto };
      }
      this.selectedStatusId = null;
      this.$refs.dialogBox.open();
    },
  },
};
</script>

<style scoped>
.outer-div{
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;

}
.title-span
{
  color: #000;
  font-size: 18px;
  font-weight: 500;
}

.desc-div
{
  padding-top: 10px;
  padding-bottom: 10px;
  padding-left: 8px;
  padding-right: 8px;
  border: 1px solid #BDBDBD;
  border-radius: 6px;
  background-color: #F9F9FA;
}

.desc-span
{
  color: #000;
  font-size: 20px;
}
</style>
